<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <stock-logs :isActive="activeLogs" :preSelectedStockCode="selectedStockCode" @close="activeLogs = false; selectedStockCode = null"/>
    <set-stock-limits :isActive="activeLimits" @close="activeLimits = !activeLimits"/>
    <vs-popup class="holamundo" title="Hammadde Sil" :active.sync="deletePopupActive" v-esc="escapeDelete">
      <div class="w-full" @keyup.enter="deleteData(deletedId)">
        <vs-row vs-type="flex" vs-w="12">
          <p>Bu Hammaddeyi Silmek İstediğinize Eminmisiniz ? </p>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
          <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç
          </vs-button>
          <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
                     @click="deleteData(deletedId)">
            Sil
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>

    <vs-table id="stockDataList" ref="table" :data="stocks" :max-items="itemsPerPage" v-model="selected">

      <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
        <div class="mb-1 w-full">
          <global-filter ref="filterer" :tableOptions="tableOptions" :filterOptions="filterOptions"
                         :filterChips="filterChips" :filterOptionNames="filterOptionNames" :isActive="isFilterActive"
                         @saveOptions="saveOptions" @close="isFilterActive = false;"/>
          <div id="panelHeaderRow" v-show="!isFilterActive" class="flex items-center justify-between w-full p-2 bg-white rounded-lg">
            <div id="panel-actions" class="flex items-center gap-2">
              <vx-tooltip text="Detaylı Filtereleme" position="top">
                <vs-button @click="isFilterActive = !isFilterActive;"
                           class="panel-action text-warning xlarge-button panel-action-box-shadow"
                           color="transparent"
                           icon-pack="pickicon" icon="icon-pick-filter">
                </vs-button>
              </vx-tooltip>
              <vx-tooltip text="Stok Hareketleri" position="top">
                <vs-button @click="activeLogs = !activeLogs"
                           class="panel-action text-dark xlarge-button panel-action-box-shadow" color="transparent"
                           icon-pack="pickicon" icon="icon-checklist"/>
              </vx-tooltip>
              <vx-tooltip text="Excel Export" position="top">
                <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                           color="transparent" icon-pack="feather" icon="icon-download"/>
              </vx-tooltip>
              <vx-tooltip v-if="$isCenterBranch()" text="Stok Limitleri Belirle" position="top">
                <vs-button @click="activeLimits = !activeLimits"
                           class="panel-action text-dark xlarge-button panel-action-box-shadow"
                           color="transparent"
                           icon-pack="feather" icon="icon-bar-chart"/>
              </vx-tooltip>
            </div>
            
            <div id="filter-chips" v-if="filterChips.length > 0" class="flex items-center justify-center flex-grow mx-4">
              <vs-button id="clearFilterButton" @click="clearFilter"
                         class="mr-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather"
                         icon="icon-slash" radius
                         color="transparent"/>
              <div class="flex flex-wrap gap-2 justify-center">
                <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col,index)"
                         v-for="(chip,index) in filterChips" :key="index"
                         v-show="chip.value != '' " closable>
                  <span class="bold text-xsmaller text-dark">{{ chip.name + ' :' }}</span>
                  <span class="weight-600 italic text-xsmaller text-primary ml-1">{{ chip.value }}</span>
                </vs-chip>
              </div>
            </div>
            
            <div id="table-page-size" class="flex items-center justify-end">
              <vs-dropdown vs-trigger-click class="bg-white cursor-pointer panel-action-box-shadow">
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small h-10">
                  <span class="mr-2 page-size-dropdown-span">{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0 ? (currentPage + 1) * itemsPerPage : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage=10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage=15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage=20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
      </div>

      <template slot="thead">

        <vs-th class="w-1/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.StockCode') ? sortingHeadIcon : null" color="primary"
                     type="flat" @click="setSortingOptions('rawMaterial.StockCode')">Kod
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.RawMaterialCategory.Name') ? sortingHeadIcon : null" color="primary"
                     type="flat"
                     @click="setSortingOptions('rawMaterial.RawMaterialCategory.Name')">Kategori
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.Name') ? sortingHeadIcon : null" color="primary"
                     type="flat"
                     @click="setSortingOptions('rawMaterial.Name')">İsim
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'buyPrice') ? sortingHeadIcon : null" color="primary" type="flat"
                     @click="setSortingOptions('buyPrice')">Maaliyet
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'buyPrice') ? sortingHeadIcon : null" color="primary" type="flat"
                     @click="setSortingOptions('buyPrice')">Toplam Maaliyet
          </vs-button>
        </vs-th>
        <vs-th v-if="isQuantityPermission" class="w-2/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'totalQuantity') ? sortingHeadIcon : null" color="primary"
                     type="flat"
                     @click="setSortingOptions('totalQuantity')">Miktar
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.Supplier.Name') ? sortingHeadIcon : null"
                     color="primary"
                     type="flat" @click="setSortingOptions('rawMaterial.Supplier.Name')">Tedarikçi
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12" v-if="$isCenterBranch()">
          <vs-button class="p-1 weight-600" color="primary" disabled="true" type="flat">İşlem</vs-button>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="openStockLogs(tr)" class="cursor-pointer">

          <vs-td class="w-1/12">
            <p class="text-center font-bold">{{ tr.rawMaterial ? tr.rawMaterial.stockCode : '-' }}</p>
          </vs-td>
          <vs-td class="w-3/12">
            <p class="text-center text-grey">{{ tr.rawMaterial ? tr.rawMaterial.rawMaterialCategoryName : '-' }}</p>
          </vs-td>
          <vs-td class="w-3/12">
            <p class="text-center font-semibold text-dark">{{ tr.rawMaterial ? tr.rawMaterial.name : '-' }}</p>
          </vs-td>

          <vs-td class="w-2/12">
            <p class="text-center m-auto" style="width:fit-content;">
              <span class="currency-badge">
                {{ tr.rawMaterial ? $toCurrency(tr.rawMaterial.buyPrice) : '-' }}
              </span>
              <vs-chip color="transparent" class="text-dark ml-1 font-semibold">%{{ tr.rawMaterial ? tr.rawMaterial.kdv : '0' }}</vs-chip>
            </p>
          </vs-td>
          <vs-td class="w-1/12">
            <p class="text-center m-auto" style="width:fit-content;">
              <span class="currency-badge">
                {{ $toCurrency(tr.totalPrice) }}
              </span>
            </p>
          </vs-td>
          <vs-td v-if="isQuantityPermission" class="w-2/12">
            <p class="text-center m-auto" style="width:fit-content;">
              <span class="quantity-badge notranslate" translate="no" :class="getQuantityBadgeClass(tr.totalQuantity)">
                {{ formatQuantity(tr.totalQuantity) }} {{ tr.rawMaterial && tr.rawMaterial.unit ? tr.rawMaterial.unit.name : '' }}
              </span>
            </p>
          </vs-td>

          <vs-td class="w-2/12">
            <p class="text-center text-grey">{{ (tr.rawMaterial && tr.rawMaterial.supplier) ? tr.rawMaterial.supplier.name : '-' }}</p>
          </vs-td>

          <vs-td class="w-1/12" v-if="$isCenterBranch()">
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current text-grey" class="ml-2"
                          @click.stop="deletedId = tr.id;deletePopupActive = true;"/>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default :setCurrentPage="tableOptions.pageIndex" :totalLenght="calculatePageLength"
                        @currentPage="getCurrentPage"></pagination-default>
  </div>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import PaginationDefault from "../PaginationDefault";
import moduleStock from "@/store/stock/moduleStock.js";
import StockLogs from "./StockLogs.vue";
import SetStockLimits from "./SetStockLimits";
import {isGranted} from "@/utils/auth";
import {
  deleteStock,
  getExcel
} from "@/api/Stock";
/* eslint-disable */
export default {
  components: {
    PaginationDefault,
    StockLogs,
    GlobalFilter,
    SetStockLimits
  },
  data() {
    return {
      activeLimits: false,
      deletePopupActive: false,
      deletedId: null,
      selected: "",

      activeLogs: false,
      selectedStockCode: null,
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      tableOptions: {},
      isFilterActive: false,
      filterOptions: ["branch", "stockCode", "stock", "cost", "quantity", "supplier"],
      filterOptionNames: ["Şube", "Stok Kodu", "Stok", "Maaliyet", "Miktar", "Tedarikçi"],
      filterChips: []
    };
  },
  computed: {
    stocks() {
      return this.$store.state.stock.stocks;
    },
    totalDataRow() {
      return this.$store.state.stock.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return (mod > 0) ? ((this.totalDataRow - mod) / this.itemsPerPage) + 1 : this.totalDataRow / this.itemsPerPage;
    },
    isQuantityPermission(){
      return isGranted("stock_quantity_read")
    }
  },
  methods: {
    getExcel() {
      getExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Stok Listesi' + now.getDate() + " " + this.$months()[now.getMonth()]
              .name +
            " " + now.getFullYear() + '.xlsx');
        
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "RawMaterial.RawMaterialCategory.Name",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: this.$currentUser.branch,
        stockCode: null,
        stock: null,
        cost: {
          min: null,
          max: null
        },
        quantity: {
          min: null,
          max: null
        },
        supplier: null
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    escapeDelete() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    deleteData(id) {
      deleteStock(id).then(res => {
        if (res && res.status == 200) {
          this.$store.dispatch("stock/removeStock", id).then((data) => {
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "Stok Başarıyla Silindi"
            });
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !"
          });
        }
      });
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? this.selected = "" : null;
    },
    getStockList: _.debounce(function () {
      this.$store.dispatch("stock/fetchDataListItemsStock", this.tableOptions).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error
        });
      });
    }, 150),
    openStockLogs(tr) {
      if (tr && tr.rawMaterial) {
        this.selectedStockCode = tr.rawMaterial.stockCode;
        this.activeLogs = true;
      }
    },
    getQuantityBadgeClass(qty) {
      if (qty <= 0) return 'critical';
      if (qty < 10) return 'warn';
      return 'ok';
    },
    formatQuantity(val) {
      if (val === null || val === undefined) return '-';
      return Number(val).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 4 });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    }
  },
  created: function () {
    if (!moduleStock.isRegistered) {
      this.$store.registerModule("stock", moduleStock);
      moduleStock.isRegistered = true;
    }
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.getStockList();
      }
    },
    currentPage: function () {
      this.tableOptions.pageIndex = this.currentPage;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    }
  }
};

</script>

<style scoped>
.data-list-container {
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
}

#panelHeaderRow {
  background: #ffffff;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
  align-items: center;
}

.panel-action {
  transition: all 0.3s ease;
  border-radius: 8px !important;
}

.panel-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
}

.xlarge-button {
  padding: 12px 16px !important;
}

/* Table styling */
#stockDataList {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.03);
  padding: 1rem;
}

#stockDataList .con-tablex {
  max-height: calc(100vh - 215px);
  overflow-y: auto;
}

.vs-table--thead th {
  background: #f1f3f5;
  color: #495057;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  border: none;
  padding: 12px 10px;
}

.vs-table--thead th .vs-button {
  font-size: 0.75rem;
  font-weight: 700;
  color: #495057 !important;
}

.vs-table--tr {
  transition: all 0.2s ease-in-out;
  border-bottom: 1px solid #e9ecef;
}

.vs-table--tr:hover {
  background: rgba(var(--vs-primary), 0.04) !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* Quantity status styling */
.quantity-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 700;
  display: inline-block;
  font-size: 0.85rem;
}

.quantity-badge.ok {
  background-color: rgba(var(--vs-success), 0.12);
  color: rgb(var(--vs-success));
}

.quantity-badge.warn {
  background-color: rgba(var(--vs-warning), 0.12);
  color: rgb(var(--vs-warning));
}

.quantity-badge.critical {
  background-color: rgba(var(--vs-danger), 0.12);
  color: rgb(var(--vs-danger));
}

.currency-badge {
  font-weight: 600;
  background-color: rgba(var(--vs-primary), 0.1);
  color: rgb(var(--vs-primary));
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.85rem;
}

.text-grey {
  color: #6c757d;
}
</style>

